import { Link } from 'react-router-dom';
import { React, useEffect, useState } from 'react';
import { retrieveToken } from '../../../hooks/use-token';
import { handleMyCourses } from '../../../api/pagamento';
import { aulasAssistidas } from '../../../api/aluno';
import { useNavigate } from "react-router-dom";

const MeusCursosTable = () => {
  
const [allCursos, setAllCursos] = useState([]);
const [flagApi, setFlagApi] = useState(false);
const [assistidas, setAssistidas] = useState([]);
const navigate = useNavigate();

  useEffect(() => {
    
    const tokenApi = retrieveToken();
    
    if (allCursos.length == 0 && flagApi == false) {

      handleMyCourses(tokenApi).then(function(result) {
          setAllCursos(result);
            setFlagApi(true);
        }).catch(function(error) {
          if (error.message === 'Unauthorized') {
              navigate("/entrar");
          } else {
              console.error('Erro ao obter cursos:', error);
          }
      });

    }

  });

  useEffect(() => {
    if (allCursos.length > 0) {

      const tokenApi = retrieveToken();

      allCursos.map((curso, index) => {
        aulasAssistidas(tokenApi, curso.cd_curso, null).then(function(result) {
          if (result) {
            setAssistidas((prevAssistidas) => [...prevAssistidas, parseInt(parseInt(result.aulasAssistidas)*100/parseInt(result.aulasCurso))]);
          }
        });
      });

    }
  }, [allCursos])

  useEffect(() => {
    console.log('assistidas', assistidas)
  }, [assistidas])

  return (
    <div className="table-content table-responsive" style={{marginTop: 35}}>
    <table className="table">
      <thead>
        <tr>
          <th className="product">Nome</th>
          <th className="product">Status</th>
          <th className="product">Qtd Redações</th>
          <th className="product-price">Acessar</th>
        </tr>
      </thead>
      <tbody>
          {allCursos.length > 0 && allCursos.map((curso, index) => (
              <tr>
                  <td>
                          {(curso.pagamento.flag_ativo == "1" && curso.pagamento.flag_status == "2") && <Link to={`/curso/${curso.cd_curso}/modulos`}><img src={"https://v1.profaprizattera.com.br/uploads/curso/" + curso.file} width="230" alt={curso.nome} /></Link>}
                          {(curso.pagamento.flag_ativo == "0") && <Link to={`/curso-detalhes/${curso.cd_curso}`}><img src={"https://v1.profaprizattera.com.br/uploads/curso/" + curso.file} width="230" alt={curso.nome} /></Link>}
                            
                          <h4 className="mt-10">{curso.nome}</h4>
                          
                          <div className="">
                          <div className="progress">
                            <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{width: `${assistidas[index]}%`}} aria-valuenow={`${assistidas[index]}`} aria-valuemin="0" aria-valuemax="100">{assistidas[index]}% concluído</div>
                          </div>
                          
                          </div>
                         
                    </td>
                  <td>{(curso.pagamento.flag_ativo == "1" && curso.pagamento.flag_status == "2") ? "Ativo" : "Inativo"}</td>
                  <td>{curso.plano.qtd_redacao}</td>
                  <td>
                    {(curso.pagamento.flag_ativo == "1" && curso.pagamento.flag_status == "2") && <Link to={`/curso/${curso.cd_curso}/modulos`} className="e-btn e-btn-7 mt-15">Acessar</Link>}
                    {(curso.pagamento.flag_ativo == "0") && <span className="" disabled>Inativo</span>} 
                  </td>
              </tr>
          ))}
      </tbody>
    </table>
    <p className="mt-35">Caso esteja encontrando alguma dificuldade com relação ao seu pagamento, entre em contato conosco.</p>
    </div>
  );

  };
  
  export default MeusCursosTable;